<div class="addPettyImage">
    <div class="addPettyImageHeader">
        <div [ngClass]="currentStep == 1?'active':currentStep > 1?'previous':''">
            <span>1</span>
            Select Photo
        </div>
        <div [ngClass]="currentStep == 2?'active':currentStep > 2?'previous':''">
            <span>2</span>
            Crop Photo
        </div>
        <div [ngClass]="currentStep == 3?'active':currentStep > 3?'previous':''">
            <span>3</span>
            Save Photo
        </div>
    </div>

    <div class="addPettyImageBody">
        <div *ngIf="currentStep == 1">
            <div *ngIf="popupType === 'Upload'">
                <input type="file" (change)="fileChangeEvent($event)" style="display: none;" #imgPopup />
                <a (click)="imgPopup.click()" class="choseImgStyle">Choose an Image</a>
            </div>
        </div>
        <div *ngIf="currentStep == 2">
            <div *ngIf="popupType === 'Upload'" class="containSelectedImageCropperFix">
                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="false"
                    [onlyScaleDown]="false" [aspectRatio]="1/1" [resizeToWidth]="300"  [resizeToHeight]="300" format="png"
                    (imageCropped)="imageCropped($event)"></image-cropper>
            </div>
            <div *ngIf="popupType === 'Cam'">
                <div class="snapshot" *ngIf="webcamImage">
                    <image-cropper [maintainAspectRatio]="false" [aspectRatio]="1 / 1" format="jpeg"
                        [resizeToWidth]="300"
                        [resizeToHeight]="300"
                        [cropperMinWidth]="100"
                        [cropperMinHeight]="100"
                        [imageBase64]="webcamImage.imageAsDataUrl"
                        (imageCropped)="imageCropped($event)"></image-cropper>
                </div>
            </div>
        </div>
        <div *ngIf="currentStep == 3">
            <img [src]="croppedImage" />
        </div>
    </div>
    <div class="addProfilePicfooter">
        <div>
            <button class="tryAnother" (click)="resetAll()"
                [ngStyle]="{display:currentStep != 1?'inline-block':'none'}">Try Another Img</button>
        </div>
        <div>
            <button class="cancel" (click)="closePopup()">Cancel</button>
            <button class="Save" *ngIf="currentStep == 1 && popupType === 'Cam'" (click)="triggerSnapshot()">Take Picture</button>
            <button class="Save" *ngIf="currentStep == 2" (click)="next()">Crop Picture</button>
            <button class="Save" *ngIf="currentStep == 3" (click)="finish()">Done</button>
            <div *ngIf="currentStep == 3">
                <p>Image Dimensions: {{ imageWidth }} x {{ imageHeight }}</p>
                <p>Image Size: {{ imageSize }} KB</p>
            </div>
        </div>
    </div>
</div>